import { SvgIcon, SvgIconProps } from '@mui/material';

const ReportSvgIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H23C23.5523 6 24 6.44772 24 7V25C24 25.5523 23.5523 26 23 26H9C8.44772 26 8 25.5523 8 25V13C8 12.7348 8.10536 12.4804 8.29289 12.2929L14.2929 6.29289ZM22 8H16V13C16 13.5523 15.5523 14 15 14H10V24H22V8ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H12ZM11 21C11 20.4477 11.4477 20 12 20H20C20.5523 20 21 20.4477 21 21C21 21.5523 20.5523 22 20 22H12C11.4477 22 11 21.5523 11 21ZM19 12H18C17.4477 12 17 12.4477 17 13C17 13.5523 17.4477 14 18 14H19H20C20.5523 14 21 13.5523 21 13C21 12.4477 20.5523 12 20 12H19Z"
        fill="#3E3E3E"
      />
    </SvgIcon>
  );
};

export default ReportSvgIcon;
